import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as moment from 'moment';
import { DialogComponent } from 'src/app/dialog.component';
import { Router } from '@angular/router';
// import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';



@Component({
    selector: 'app-status-modal',
    templateUrl: './status-modal.component.html'
})
export class StatusModalComponent implements OnInit {
    savingFlag: boolean = false;
    segment: any = {};
    category: any = {};
    travelForm: any = {};
    login: any = {};
    delivery_from: any;
    userData: any;
    userId: any;
    userName: any;
    salesUser: any = [];
    ActiveTab: any = 'incoming'
    tabType: any = 'stock'
    stockDetails: any = [];
    dr_outDetails: any = [];
    transferRequestData: any = [];
    dr_inDetails: any = [];
    reqProductDetails: any = [];
    stockRequestDetails: any = [];
    sendProductDetails: any = [];
    organisationData: any = [];
    assignDistArray: any = [];
    drlist: any = [];
    tmpOrderStatus: any = '';
    segmentList: any = [];
    dr_data: any = [];
    states: any = [];
    order_item: any = [];
    networkType: any = [];
    warehouse: any = [];
    today_date: any = new Date()
    add_list: any = [];
    networklist: any = [];
    networklist2: any = [];
    productlist: any = [];
    productlist2: any = [];
    tempSearch: any = '';
    stockForm: any = {};
    years: number[];
    city_list: any = [];
    city_list1: any = [];
    expense_id: any;
    urls = new Array<string>();
    selectedFile = [];
    checkinDetail: any;
    excel_data: any;
    downurl: any;
    reportData: any = [];
    attendance_id: any;
    partyList: any;


    constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public dialog1: DialogComponent, public serve: DatabaseService, public session: sessionStorage, public route: Router, public toast: ToastrManager, public dialogRef: MatDialogRef<StatusModalComponent>,) {
        this.userData = JSON.parse(localStorage.getItem('st_user'));
        this.data.checkWareHouse = "No";
        this.segment = this.data.segment;
        this.userId = this.userData['data']['id'];
        this.userName = this.userData['data']['name'];
        this.downurl = serve.downloadUrl;
        this.delivery_from = this.data.delivery_from;
        this.expense_id = this.data.expense_id;
        this.attendance_id = this.data.attendance_id;
        console.log(this.delivery_from)
        if (this.data.from == 'primary_order') {
            for (let i = 0; i < this.data.order_item.length; i++) {
                this.order_item.push({ 'id': this.data.order_item[i]['id'], 'product_name': this.data.order_item[i]['product_name'], 'product_code': this.data.order_item[i]['product_code'], 'order_qty': this.data.order_item[i]['qty'], 'qty': this.data.order_item[i]['sale_dispatch_qty'], 'dispatch_qty': parseInt(this.data.order_item[i]['qty']) - parseInt(this.data.order_item[i]['sale_dispatch_qty']) })
            }

        }

        if (this.data.FsCat == true) {
            this.data.organisation_id = '2'
        }

        this.tmpOrderStatus = this.data.order_status;
        if (this.tmpOrderStatus) {
            this.data.order_status = '';
            this.data.reason = '';
        }

        this.selectCity('');
        this.selectCity1('');
    }

    ngOnInit() {
        if (this.delivery_from == 'assignDist') {
            this.distributorList('', this.data.state)
            this.distributorDetail();

        } else if (this.delivery_from == 'assignSales') {
            this.distributorDetail();
            this.getSalesUser('')
        }
        else if (this.delivery_from == 'assignSales1' || this.delivery_from == 'LeadReport') {

            this.getSalesUser('')
        }
        else if (this.delivery_from == 'distributionDetail') {

            this.getPartyList('')
        }
        else if (this.delivery_from == 'subcategory-list') {
            this.data.segment_id = this.data.master_category_id.toString();
            this.getSegment();
        }
        else if (this.delivery_from == 'edit_travel_plan_retailer') {
            this.data.employee_id = this.data.employee_id.toString();
            this.data.id = this.data.travel_plan_id.toString();
            this.data.distributor_id = this.data.drId.toString();
            this.allCustomerNetworkList('');
        }
        else if (this.delivery_from == 'add_travel_plan_retailer') {
            this.data.employee_id = this.data.employee_id.toString();
            this.data.id = this.data.travel_plan_id.toString();
            this.allCustomerNetworkList('');

        }
        else if (this.delivery_from == 'month_wise_secondary_sale') {
            this.getStateList();

        }
        else if (this.delivery_from == 'Daily-Working-Style-Report-of-Individual-Employee' || this.delivery_from == 'Monthly-Working-Style-Report-of-Individual-Employee' || this.delivery_from == 'Individual-Performance' || this.delivery_from == 'MRM-analysis-Report' || this.delivery_from == 'leadReport' || this.delivery_from == 'Daily-Report' || this.delivery_from == 'Lead-Report' || this.delivery_from == 'Overall-Data-Report' || this.delivery_from == 'Monthly-Projection-Vs-Achievement-Report') {
            this.getSalesUser('')

        }
        else if (this.delivery_from == 'Monthly-TA-Expense-Report' || this.delivery_from == 'BTL-Expense-Report' || this.delivery_from == 'Travel-Report') {
            this.getSalesUser1('')

        }
        else if (this.delivery_from == 'Expense-Report') {
            this.getSalesUser1('')

        }
        else if (this.delivery_from == 'ProductWisePrimaryReport') {
            this.getSalesUser('')
        }
        else if (this.data.from == 'request_product_data') {
            this.reqProductDetails = this.data.reqProductData.product_details;
        }
        else if (this.data.from == 'stockRequestDetailsModal') {
            this.stockRequestDetails = this.data.reqProductData;
        }

        else if (this.data.from == 'send_product_data') {
            this.sendProductDetails = this.data.sendProductData.product_details;
        }
        else if (this.data.from == 'stock_product_trans') {
            this.dr_outDetails = this.data.stockProductTrans.dr_out;
            this.dr_inDetails = this.data.stockProductTrans.dr_in;
        }
        else if (this.data.from == 'sendStockToRetailer') {
            this.getNetworkList('');
            this.stockForm.type = this.data.type;
        }
        else if (this.data.from == 'add_new_follow_up') {
            this.getSalesUser('')
        }
        else if (this.data.from == 'approve_transfer_equest') {
            this.transferRequestData = this.data.requestData;
            this.data.requestId = this.transferRequestData.id;
        }

        this.login = JSON.parse(localStorage.getItem('login'));
    }
    reason_reject: any
    primary_order_status_change(reason, status) {
        if (status == 'readyToDispatch') {
            for (let i = 0; i < this.order_item.length; i++) {
                let indexValue = i + 1;
                if (this.order_item[i]['qty'] == 0) {
                    if ((parseInt(this.order_item[i]['dispatch_qty'])) > this.order_item[i]['order_qty']) {
                        this.toast.errorToastr('Row number ' + indexValue + ' remaining QTY. can not be greater than QTY.');
                        return;
                    }
                }
                if (this.order_item[i]['qty'] > 0) {
                    if (parseInt(this.order_item[i]['dispatch_qty']) > parseInt(this.order_item[i]['order_qty']) - parseInt(this.order_item[i]['qty'])) {
                        let value = parseInt(this.order_item[i]['order_qty']) - parseInt(this.order_item[i]['qty'])
                        this.toast.errorToastr('Row number ' + indexValue + ' Dispatch QTY. can not be greater than remaining QTY. ' + value);
                        return;
                    }
                }
            }
            this.dialog1.confirm('You want to update dispatch planned?').then((result) => {
                if (result) {
                    this.savingFlag = true;
                    this.serve.post_rqst({ 'dispatch_item': this.order_item, 'status': status, 'id': this.data.order_id, 'organisation_id': this.data.organisation_id, 'warehouse_id': this.data.warehouse_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "dispatch/dispatchOrderCreate").subscribe((result => {
                        if (result['statusCode'] == 200) {
                            this.dialog.closeAll();
                            this.savingFlag = false;
                            this.toast.successToastr(result['statusMsg']);
                        }
                        else {
                            this.savingFlag = false;
                            this.toast.errorToastr(result['statusMsg'])
                        }
                    }))
                }
            });



        }
        else {
            this.dialog1.confirm('You want to change status?').then((result) => {

                if (result) {
                    if (this.data.dipatch_date) {
                        this.data.dipatch_date = moment(this.data.dipatch_date).format('YYYY-MM-DD');
                        this.data.dipatch_date = this.data.dipatch_date;
                    }
                    this.savingFlag = true;
                    this.serve.post_rqst({ 'reason': reason, 'status': status, 'warehouse_id': this.data.warehouse_id, 'id': this.data.order_id, 'organisation_id': this.data.organisation_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName, 'dispatch_date': this.data.dipatch_date }, "Order/primaryOrderStatusChange").subscribe((result => {
                        if (result['statusCode'] == 200) {
                            this.savingFlag = false;
                            this.toast.successToastr(result['statusMsg']);
                            if (status == 'despatched') {
                                this.dialogRef.close({ open_add_item: true });
                            } else {
                                this.dialog.closeAll();
                            }
                        }
                        else {
                            this.savingFlag = false;
                            this.toast.errorToastr(result['statusMsg'])
                        }

                    }))
                }
            });


        }

    }
    DailyReportList() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigate(['/report-list/report/Daily-Working-Style-Report-of-Individual-Employee'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'Daily-Working-Style-Report-of-Individual-Employee' } })
        this.dialog.closeAll();

    }


    ExpenseReportList(type) {
        if (type == 'Expense-Report') {



            this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
                this.route.navigate(['/report-list/report/Expense-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'year': this.data.year, 'month': this.data.month, 'types': type } })
            });
            this.dialog.closeAll();
        }
        else {
            this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
                this.route.navigate(['/report-list/report/BTL-Expense-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'year': this.data.year, 'month': this.data.month, 'types': type } })
            });
            this.dialog.closeAll();
        }




    }
    DailyReportListDate() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.end_date = moment(this.data.end_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Daily-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date_from': this.data.start_date, 'date_to': this.data.end_date, 'types': 'Daily-Report' } })
        });
        this.dialog.closeAll();

    }
    LateReport() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Late-Report'], { queryParams: { 'date_from': this.data.start_date, 'types': 'Late-Report' } })
        });
        this.dialog.closeAll();

    }
    LateCheckinReport() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Late-Check-In-Report'], { queryParams: { 'date_from': this.data.start_date, 'types': 'Late-Check-In-Report' } })
        });
        this.dialog.closeAll();

    }
    MonthReportList() {
        var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Monthly-Working-Style-Report-of-Individual-Employee'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'Monthly-Working-Style-Report-of-Individual-Employee' } })
        });

        this.dialog.closeAll();

    }
    MonththlyProjectionVsAchievementReport() {
        var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Monthly-Projection-Vs-Achievement-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'Monthly-Projection-Vs-Achievement-Report' } })
        });

        this.dialog.closeAll();

    }
    TAExpenseList() {
        var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Monthly-TA-Expense-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'Monthly-TA-Expense-Report' } })
        });

        this.dialog.closeAll();

    }
    LeadReport() {
        let existIndex = this.salesUser.findIndex(row => row.id == this.data.assigned_sales_user_name);

        if (existIndex !== -1) {
            this.data.name = this.salesUser[existIndex].name;
            this.data.employee_id = this.salesUser[existIndex].employee_id;
        }
        // var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        // var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        // this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.date_from ? (this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD')) : null;
        this.data.date_to ? (this.data.date_to = moment(this.data.date_to).format('YYYY-MM-DD')) : null;
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Lead-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date_from': this.data.date_from, 'date_to': this.data.date_to, 'types': 'Lead-Report', 'employee_id': this.data.employee_id, 'name': this.data.name, } })
        });

        this.dialog.closeAll();

    }
    TotalExpenseList() {
        var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Total-Expense-Report'], { queryParams: { 'date': this.data.start_date, 'types': 'Total-Expense-Report' } })
        });
        this.dialog.closeAll();

    }
    MRMReport() {
        var year = this.data.year; // Assuming year is known

        // Assuming this.data.month is the month in "01", "02", "03" format
        var month = this.data.month;

        // Construct the date string in YYYY-MM-DD format
        this.data.start_date = year + "-" + month + "-01";

        // this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.route.navigate(['/report-list/report/MRM-analysis-Report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'MRM-analysis-Report' } })

        this.dialog.closeAll();

    }
    leadReport() {

        let existIndex = this.salesUser.findIndex(row => row.id == this.data.assigned_sales_user_name);

        if (existIndex !== -1) {
            this.data.name = this.salesUser[existIndex].name;
            this.data.employee_id = this.salesUser[existIndex].employee_id;
        }
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/primary-target-report'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'employee_id': this.data.employee_id, 'name': this.data.name, 'month': this.data.month, 'year': this.data.year } })
        });
        this.dialog.closeAll();

    }
    IndividualReportList() {
        var year = this.data.year;

        var month = this.data.month;

        this.data.start_date = year + "-" + month + "-01";
        this.route.navigateByUrl('/report-list/report/', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/report-list/report/Individual-Performance'], { queryParams: { 'id': this.data.assigned_sales_user_name, 'date': this.data.start_date, 'types': 'Individual-Performance' } })
        });
        this.dialog.closeAll();

    }
    selectCity(search) {
        this.serve.post_rqst({ 'search': search }, "Expense/get_city_list").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.city_list = result['city'];
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }));



    }
    selectCity1(search) {
        this.serve.post_rqst({ 'search': search }, "Expense/get_city_list").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.city_list1 = result['city'];
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }));



    }

    fileChange(event: any) {
        for (var i = 0; i < event.target.files.length; i++) {
            this.selectedFile.push(event.target.files[i]);
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.urls.push(e.target.result);
                for (let index = 0; index < this.selectedFile.length; index++) {
                    for (let urlIndex = 0; urlIndex < this.urls.length; urlIndex++) {
                        if (index == urlIndex) {
                            this.selectedFile[index]['path'] = this.urls[urlIndex];
                        }
                    }
                }
            }
            reader.readAsDataURL(event.target.files[i]);
        }
    }
    remove_image(i: any) {
        this.urls.splice(i, 1);
        this.selectedFile.splice(i, 1);
    }
    AddExpense() {
        this.travelForm.expense_id = this.expense_id
        this.travelForm.image = this.selectedFile
        this.serve.post_rqst({ 'data': this.travelForm }, "Expense/add_onemore_expense").subscribe((result => {
            if (result['statusCode'] == 200) {

                this.toast.successToastr(result['statusMsg']);
                this.dialog.closeAll();
            }
            else {


                this.toast.errorToastr(result['statusMsg']);
            }
        }));



    }

    AddAttendanceType() {
        this.data.expense_id = this.attendance_id

        this.serve.post_rqst({ 'data': this.data }, "Attendance/attendanceTypeUpdate").subscribe((result => {
            if (result['statusCode'] == 200) {

                this.toast.successToastr(result['statusMsg']);
                this.dialog.closeAll();
            }
            else {


                this.toast.errorToastr(result['statusMsg']);
            }
        }));



    }


    selectWarehouse(value) {
        if (value.value == "Yes") {
            this.serve.post_rqst({}, "Dispatch/fetchWarehouse").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.warehouse = result['result'];
                }
                else {
                    this.toast.errorToastr(result['statusMsg']);
                }
            }));

        }
        else {
            this.data.warehouse_id = '';
            this.warehouse = [];
        }

    }
    secondary_order_status_change(reason, status) {
        this.savingFlag = true;
        this.serve.post_rqst({ 'reason': reason, 'status': status, 'id': this.data.order_id, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Order/secondaryOrderStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }

    inventory_status_change() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Influencer/inventoryStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }

    secondary_order_remark() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'remark': this.data.activity_remark, 'order_id': this.data.order_id }, "Order/secondaryOrderChatLogs").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }



    getCompanyData() {
        this.serve.post_rqst({}, "Order/organizationName").subscribe((response => {
            if (response['statusCode'] == 200) {
                this.organisationData = response['result'];
            } else {
                this.toast.errorToastr(response['statusMsg']);
            }

        }));
    }

    distributorList(searcValue, state) {
        this.serve.post_rqst({ 'search': searcValue, 'state': state }, "CustomerNetwork/distributorsList").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.drlist = result['distributors'];

            } else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }
    distributorDetail() {
        let id = { "id": this.data.drId }
        this.serve.post_rqst(id, "CustomerNetwork/distributorDetail").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.data = result['distributor_detail'];
                this.data.id = result['distributor_detail']['id'];
                this.data.assigned_sales_user_name = this.data['assigned_sales_user_name'].map(String);
                this.data.distributor_id = this.data['distributors_id'].map(String);
            }
            else {
                this.toast.errorToastr(result['statusMsg'])
            }
        }
        )
    }


    allCustomerNetworkList(searcValue) {
        this.drlist = [];
        this.serve.post_rqst({ 'search': searcValue, 'type': this.data.drType, 'employee_id': this.data.employee_id }, "Travel/drList").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.drlist = result['result'];
            } else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }


    getSegment() {
        this.serve.post_rqst({}, "Master/getProductCategoryList").subscribe((result => {
            if (result['category_list']['statusCode'] == 200) {
                this.segmentList = result['category_list']['segment_list'];
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['category_list']['statusCode'])
            }
        }))
    }

    UpdateSalesUser2() {

        let index = this.salesUser.findIndex(row => row.id == this.data.assigned_sales_user_name)
        if (index != -1) {
            this.data.user_name = this.salesUser[index].name;
        }

        this.savingFlag = true;
        setTimeout(() => {
            this.serve.post_rqst({ 'data': this.data.Site_detail, 'user_id': this.data.assigned_sales_user_name, 'user_name': this.data.user_name, 'id': this.data.Site_detail.id }, "Enquiry/user_site_aasigned").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialog.closeAll();
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 2000);
    }

    UpdateSalesUser1() {
        if (this.data.Site_detail.stage_level == 'Pending') {

            let index = this.salesUser.findIndex(row => row.id == this.data.assigned_sales_user_name)
            if (index != -1) {
                this.data.user_name = this.salesUser[index].name;
            }
        }
        this.savingFlag = true;
        setTimeout(() => {
            this.serve.post_rqst({ 'data': this.data.Site_detail, 'userArray': this.data.assigned_sales_user_name }, "Enquiry/SiteUserAssign").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialog.closeAll();
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 2000);
    }
    UpdateSalesUser() {
        this.savingFlag = true;
        setTimeout(() => {
            this.serve.post_rqst({ 'drId': this.data.id, 'userArray': this.data.assigned_sales_user_name, 'company_name': this.data.company_name }, "CustomerNetwork/drUserAssign").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialog.closeAll();
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 2000);
    }
    // distArray(data){
    //   this.assignDistArray = []
    //   let index = this.drlist.findIndex(row => row.id == data)
    //   if(index != -1){
    //     this.assignDistArray.push(this.drlist[index].id)
    //   }
    // }
    UpdateDistributor() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'drId': this.data.id, 'distributorId': this.data.distributor_id }, "CustomerNetwork/dealerDistributorAssign").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }
    UpdateCustomerNetworkTravel() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'id': this.data.id, 'dr_id': this.data.distributor_id }, "Travel/drChange").subscribe((result => {
            if (result['statusCode'] == 200) {

                this.dialogRef.close(true);
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    getDrType(networkData) {
        this.dr_data.push(networkData);
    }

    AddCustomerNetworkTravel() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'id': this.data.id, 'drData': this.dr_data, 'data': this.data }, "Travel/addDr").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialogRef.close(true);
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    add_segment() {
        this.savingFlag = true;
        this.data.created_by_name = this.userName;
        this.data.created_by_id = this.userId;
        this.serve.post_rqst(this.data, "Master/addCategory").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.toast.successToastr(result['statusMsg']);
                this.savingFlag = false;
                this.dialogRef.close(true)
                this.serve.count_list();
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
                this.savingFlag = false;
            }

        }))

    }
    add_subCategory() {
        this.savingFlag = true;
        this.data.created_by_name = this.userName;
        this.data.created_by_id = this.userId;
        this.serve.post_rqst(this.data, "Master/addSubCategory").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.toast.successToastr(result['statusMsg']);
                this.savingFlag = false;
                this.dialogRef.close(true)
                this.serve.count_list();
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
                this.savingFlag = false;
            }
        }))
    }

    downloadReport() {
        this.savingFlag = true;
        this.data.date_from ? (this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD')) : null;
        this.data.date_to ? (this.data.date_to = moment(this.data.date_to).format('YYYY-MM-DD')) : null;
        let apiName = '';
        if (this.delivery_from == 'tavel_plan') {
            apiName = "Reports/TravelPlanReport"
        }


        this.serve.post_rqst({ "date_from": this.data.date_from, "date_to": this.data.date_to, 'userId': this.data.assigned_sales_user_name, }, apiName).subscribe((result: any) => {
            if (result['statusCode'] == 200) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }

    downloadReportForExp() {
        this.savingFlag = true;

        let apiName = '';
        if (this.delivery_from == 'Travel-Report') {
            apiName = "Reports/daily_expense_report"
        }


        this.serve.post_rqst({ "month": this.data.month, "year": this.data.year, 'userId': this.data.assigned_sales_user_name, }, apiName).subscribe((result: any) => {
            console.log(result)
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }



    downloadsecondarySaleReport() {
        this.savingFlag = true;
        this.serve.post_rqst({ "filter": this.data }, 'Excel/monthWiseDealerSaleReport').subscribe((result: any) => {
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }


    downloadprimaryvssecondaryReport() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.end_date = moment(this.data.end_date).format('YYYY-MM-DD');
        this.savingFlag = true;
        this.serve.post_rqst({ "filter": this.data }, 'Excel/primaryVsSecondaryReport').subscribe((result: any) => {
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }

    downloadstateWisePrimarySecondaryReport() {
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.end_date = moment(this.data.end_date).format('YYYY-MM-DD');
        this.savingFlag = true;
        this.serve.post_rqst({ "start_date": this.data.start_date, "end_date": this.data.end_date }, 'Excel/stateWisePrimarySecondaryReport').subscribe((result: any) => {
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }

    downloadorderSummaryReport() {
        this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD');
        this.data.date_to = moment(this.data.date_to).format('YYYY-MM-DD');
        this.savingFlag = true;
        this.serve.post_rqst({ filter: { "date_from": this.data.date_from, "date_to": this.data.date_to } }, 'Excel/orderSummary').subscribe((result: any) => {
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
            }
        }, () => this.savingFlag = false)
    }


    downloadproductwisePrimaryReport() {
        this.data.date_from = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.date_to = moment(this.data.end_date).format('YYYY-MM-DD');
        this.savingFlag = true;
        this.serve.post_rqst({ "search": this.data }, 'Excel/ProductWisePrimaryReport').subscribe((result: any) => {
            if (result['msg'] == true) {
                this.savingFlag = false;
                window.open(this.serve.downloadUrl + result['filename'])
                // return true;
            } else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg']);
            }
        }, () => { this.savingFlag = false; this.toast.errorToastr('Something went wrong'); })
    }


    getStateList() {
        this.serve.post_rqst(0, "Influencer/getAllState").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.states = result['all_state'];
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }));
    }

    getAssignDistributorOfSalesman(value) {
        this.serve.post_rqst({ 'userId': this.data.assigned_sales_user_name, 'search': value }, "Reports/distributorAssign").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.assignDistArray = result['result'];
            }
            else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }));
    }


    search_val: any = {}

    arrayFilter() {
        let id = this.order_item.map(e => e.product_name).indexOf(this.search_val.created_by_name);
        return id;
    }


    checkValidation(order_qty, qty, dispatch, index) {

        if (qty == 0) {
            if ((parseInt(dispatch)) > order_qty) {
                this.toast.errorToastr('Row number ' + index + ' dispatch QTY. can not be greater than QTY.');
                return;
            }
        }
        if (qty > 0) {
            if ((dispatch > parseInt(order_qty) - parseInt(qty))) {
                let value = parseInt(order_qty) - parseInt(qty)
                this.toast.errorToastr('Row number ' + index + ' dispatch QTY. can not be greater than remaining QTY. ' + value);
                return;
            }
        }

    }

    requestStatusChange(reason, status) {
        this.savingFlag = true;
        this.serve.post_rqst({ 'reason': reason, 'status': status, 'requestId': this.data.requestId, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Order/").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    salesIn: any = [];
    salesOut: any = [];

    getStock() {
        this.serve.post_rqst({ 'id': this.data.stockProductTrans.id, 'product_id': this.data.stockProductTrans.product_id, 'dr_id': this.data.id }, "stock/salesReturnPartyList").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.salesIn = result['return_in'];
                this.salesOut = result['return_out'];

            } else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }

    getPartyList(searchValue) {
        this.serve.post_rqst({ 'dr_type': this.data.type, 'search': searchValue }, 'CustomerNetwork/customerList').subscribe((response => {
            if (response['statusCode'] == 200) {
                this.partyList = response['result'];

            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }

    getSalesUser(searchValue) {
        this.serve.post_rqst({ 'search': searchValue }, 'Expense/salesUserList').subscribe((response => {
            if (response['statusCode'] == 200) {
                this.salesUser = response['all_sales_user'];

            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }
    getSalesUser1(searchValue) {
        this.serve.post_rqst({ 'search': searchValue }, 'Expense/get_sales_user_ListforTAExpense').subscribe((response => {
            if (response['statusCode'] == 200) {
                this.salesUser = response['all_sales_user'];

            } else {
                this.toast.errorToastr(response['statusMsg']);
            }
        }));
    }


    getNetworkType() {
        this.serve.post_rqst('', "Enquiry/leadNetworkModule").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.networkType = result['modules'];
            }
            else {
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    allDistributorForSelectedExecutive(searcValue) {
        this.drlist = [];
        this.serve.post_rqst({ 'search': searcValue, 'type': this.data.dr_type, 'employee_id': this.data.user_id }, "Followup/drList").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.drlist = result['result'];
            } else {
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }

    addNewFollowUp() {
        this.data.next_followup_date = moment(this.data.followup_date).format('YYYY-MM-DD');
        this.savingFlag = true;
        this.serve.post_rqst({ 'data': this.data }, "Followup/addFollowup").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.toast.successToastr(result['statusMsg']);
                this.dialog.closeAll();
                setTimeout(() => {
                    this.savingFlag = false;
                }, 700);
            }
            else {
                this.toast.errorToastr(result['statusMsg']);

            }
        }))

    }

    addIntoToList() {
        let newData
        newData = this.stockForm;
        if (this.add_list.length == 0) {
            this.add_list.push({ 'product': newData.product, 'qty': newData.qty, 'transferPoints': newData.transferPoints });
        }
        else {
            let existIndex = this.add_list.findIndex(row => (row.product.id == this.stockForm['product']['id']));
            if (existIndex != -1) {
                this.toast.errorToastr('Already same product added to items')

                // this.add_list[existIndex].qty=parseInt(this.add_list[existIndex].qty)+parseInt(newData.qty);
                // this.add_list[existIndex].transferPoints = parseInt(this.add_list[existIndex].transferPoints)+parseInt(newData.transferPoints);


            }
            else {
                this.add_list.push({ 'product': newData.product, 'qty': newData.qty, 'transferPoints': newData.transferPoints });
            }

        }
        this.stockForm.product = '';
        this.stockForm.qty = '';
        this.stockForm.transferPoints = '';
    }

    deleteItem(i) {
        this.dialog1.confirm("Delete Item From List?").then((result) => {
            if (result) {
                this.add_list.splice(i, 1);
            }
        })
    }

    searchItems(event, searchType) {
        let item = event.target.value.toLowerCase();
        this.tempSearch = '';
        if (searchType == 'dealer') {
            this.networklist = [];
            for (let x = 0; x < this.networklist2.length; x++) {
                this.tempSearch = this.networklist2[x].name.toLowerCase();
                if (this.tempSearch.includes(item)) {
                    this.networklist.push(this.networklist2[x]);
                }
            }
        }
        else {
            this.productlist = [];
            for (let x = 0; x < this.productlist2.length; x++) {
                this.tempSearch = this.productlist2[x].product_name.toLowerCase();
                if (this.tempSearch.includes(item)) {
                    this.productlist.push(this.productlist2[x]);
                }
            }
        }
    }

    getNetworkList(masterSearch) {

        this.serve.post_rqst({ 'master_search': masterSearch, 'userId': this.userId }, "Stock/assignedCustomer").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.networklist = result['result'];
                this.networklist2 = result['result'];
            } else {
                this.toast.errorToastr(result['statusMsg'])
            }
        })
    }

    getProductList(masterSearch) {
        this.serve.post_rqst({ 'master_search': masterSearch, 'userId': this.userId }, this.data.type == 'Transfer' ? 'Stock/fetchNonScannedProduct' : 'Stock/fetchProduct').subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.productlist = result['result'];
                this.productlist2 = result['result'];
            } else {
                this.toast.errorToastr(result['statusMsg'])
            }
        })
    }

    getfieldsClear() {
        this.stockForm.qty = '';
        this.stockForm.transferPoints = '';
    }

    saveStockToRetailer() {
        this.savingFlag = true;
        this.stockForm.add_list = this.add_list;
        this.serve.post_rqst({ "data": this.stockForm, 'drId': this.data.drId }, this.stockForm.type == 'Transfer' ? "Stock/sendCustomerPoints" : "Stock/salesReturnRetailer").subscribe((resp) => {
            if (resp['statusCode'] == 200 && resp['statusMsg'] == 'Success') {
                this.toast.successToastr(resp['statusMsg']);
                this.dialogRef.close();
                this.savingFlag = false;
            }
            else {
                this.toast.errorToastr(resp['statusMsg']);
                this.savingFlag = false;
            }
        }, err => {
            this.savingFlag = false;

        })
    }

    getPointCalculation(data) {
        this.stockForm.transferPoints = data.product.dealer_point * data.qty;

        if (this.stockForm.transferPoints == 0) {
            this.stockForm.transferPoints = '';
        }

    }

    stockCheck() {
        if (this.stockForm.qty > this.stockForm.product.current_stock) {
            this.toast.errorToastr('Less Stock!, Current Stock of this product is ' + this.stockForm.product.current_stock)
            this.stockForm.qty = '';
            this.stockForm.transferPoints = '';
        }
    }

    ChangeRequestStatus() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'data': this.data, 'uid': this.userId, 'uname': this.userName }, "Stock/approveRequest").subscribe((result => {
            if (result['statusCode'] == 200 && result['statusMsg'] == 'Success') {
                this.dialog.closeAll();
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    updateTarget() {
        this.savingFlag = true;

        if (this.data.from == 'target_status' && (this.data.target_type == 'Secondary Sales Projections' || this.data.target_type == 'Stock Sales Projections')) {
            let type = this.data.from == 'target_status_secondary' ? 'secondary' : 'stock';
            this.data.type = type;
            this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Target/statusSecondaryChangeTarget").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialogRef.close(true);
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }));
        }

        else if (this.data.from == 'target_status_secondary' && this.data.target_type == 'Secondary Visit Projections') {
            this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Target/visitStatusChangeTarget").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialogRef.close(true);
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }));
        }

        else if (this.data.from == 'target_status_secondary' || this.data.from == 'target_status_stock') {
            let type = this.data.from == 'target_status_secondary' ? 'secondary' : 'stock';
            this.data.type = type;
            this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Target/secStatusChangeTarget").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialogRef.close(true);
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }));
        }
        else {
            this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "Target/statusChangeTarget").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.dialogRef.close(true);
                    this.savingFlag = false;
                    this.toast.successToastr(result['statusMsg']);
                }
                else {
                    this.savingFlag = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }));
        }
    }



    updatePop() {

        if (parseFloat(this.data.approved_qty) > parseFloat(this.data.qty)) {
            this.toast.errorToastr('Approved qty can not be greater than QTY.')
            return;
        }


        this.savingFlag = true;
        this.serve.post_rqst({ 'data': this.data, 'action_by': this.login.data.id, 'uid': this.userId, 'uname': this.userName }, "PopGift/popStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.dialogRef.close(true);
                this.savingFlag = false;
                this.toast.successToastr(result['statusMsg']);
            }
            else {
                this.savingFlag = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }


    DailyDigitalEnquiryReports() {

        this.route.navigate(['/report-list/report/' + this.delivery_from], { queryParams: { 'date_from': this.data.date_from, 'date_to': this.data.date_to, 'type': this.delivery_from } })

        this.dialog.closeAll();

    }

    downloadCheckinReport() {
        this.savingFlag = true;
        this.data.date_from = moment(this.data.date_from).format('YYYY-MM-DD');
        this.serve.post_rqst(
            { "date": this.data.date_from }, "Reports/dailyCheckinCheckoutReport"
        ).subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.checkinDetail = result['result'];

                // Modified column structure as requested
                this.excel_data = this.checkinDetail.map((detail, index) => ({
                    'S.No': index + 1,
                    'Name': detail['name'] || '---',
                    'Designation': detail['designation_name'] || '---',
                    'Based': detail['working_division'] || '---',
                    'State': detail['working_state_name'] || '---',
                    'C.in T': detail['firstCheckin'] || '---',
                    'C.out T': detail['lastCheckout'] || '---',
                }));

                this.serve.exportAsExcelFile(this.excel_data, "Checkin Report");
                this.excel_data = [];
            } else {
                // Handle the case where statusCode is not 200 if needed
                this.savingFlag = false;
                this.dialog.closeAll();
            }

            this.savingFlag = false;
            this.dialog.closeAll();
        }, (error) => {
            // Handle error if needed
            console.error('Error occurred:', error);
            this.savingFlag = false;
        });
    }

    downloadLeadExcel() {
        this.savingFlag = true;
        this.serve.post_rqst({ 'userId': this.data.userId }, 'Reports/userWiseEnquiryAllStageLevelReport').subscribe((result) => {
            if (result['msg'] == true) {
                this.savingFlag = true;
                window.open(this.downurl + result['filename'])
                this.dialog.closeAll();
            } else {
                this.savingFlag = true;
            }
        });
    }

    // OverallDataReport() {
    //   const data = {
    //     "Late First Check In": [
    //       "2025-03-21(10:55 AM)"
    //     ],
    //     "Earlier Last Check Out": [
    //       "2025-03-17(1:00 PM)"
    //     ],
    //     "Travelling Time": [
    //       "2025-03-03(1 hr 10 min ,7 min (2.3 km))",
    //       "2025-03-05(2 hr 12 min ,4 min (1.1 km))",
    //       "2025-03-08(2 hr 21 min, 9 min (2.8 km))",
    //       "2025-03-18(1 hr 13 min, 17 min (1.2 km))",
    //       "2025-03-22(1 hr 27 min, 16 min (11.3 km))"
    //     ],
    //     "Travelling Time1": [
    //       "2025-03-03(1 hr 10 min ,7 min (2.3 km))",
    //       "2025-03-05(2 hr 12 min ,4 min (1.1 km))",
    //       "2025-03-08(2 hr 21 min, 9 min (2.8 km))",
    //       "2025-03-18(1 hr 13 min, 17 min (1.2 km))",
    //       "2025-03-22(1 hr 27 min, 16 min (11.3 km))"
    //     ]
    //   };


    // }

    async OverallDataReport() {
        this.savingFlag = true;
        this.data.start_date = moment(this.data.start_date).format('YYYY-MM-DD');
        this.data.end_date = moment(this.data.end_date).format('YYYY-MM-DD');
        this.serve.post_rqst({ 'id': this.data.assigned_sales_user_name, 'date_from': this.data.start_date, 'date_to': this.data.end_date, }, "Reports/overAllDataReport").subscribe(async (result) => {
            if (result['statusCode'] == 200) {
                this.reportData = result['result'];
                this.userData = result['userData'];
                const ExcelJS = await import('exceljs');
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Overall Data');
                // Add Title
                worksheet.addRow(['Overall Data Report']);
                worksheet.mergeCells('A1:G1');
                worksheet.getCell('A1').font = { bold: true, size: 14 };
                worksheet.getCell('A1').alignment = { horizontal: 'center' };
                worksheet.addRow([]); // Empty row

                // Add employee info
                worksheet.addRow(['Name:', this.userData.name || '']);
                worksheet.addRow(['Employee ID:', this.userData.employee_id || '']);
                worksheet.addRow([]); // Empty row

                // Add Headers
                const headers = ["Avg Calls", "Late First Check In", "Earlier Last Check Out", "Travelling Time", "Total Time Spend", "C-IN/C-O Diff Loc", "Multiple C-IN At One Loc", "1 Profile C-IN At Diff Loc"];
                worksheet.addRow(headers);
                worksheet.getRow(6).font = { bold: true };

                // Find max number of rows
                const lengths = Object.values(this.reportData as { [key: string]: any[] }).map(arr => arr.length);
                const maxLength = lengths.reduce((max, len) => Math.max(max, len), 0);

                // Add data rows
                for (let i = 0; i < maxLength; i++) {
                    const row = headers.map(header => this.reportData[header][i] || '');
                    worksheet.addRow(row);
                }

                // Adjust column widths
                worksheet.columns.forEach(col => {
                    col.width = 30;
                });

                // Download file
                workbook.xlsx.writeBuffer().then((buffer) => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    saveAs(blob, `Overall Data ${this.userData.name}.xlsx`);
                });

                this.savingFlag = false;
                this.dialog.closeAll();
            } else {
                this.savingFlag = false;
            }
        }, (error) => {
            console.error('Error occurred:', error);
            this.savingFlag = false;
        });
    }

    mergeParty() {
        this.dialog1.confirm('You want to Merge Party?').then((result) => {
            let api = '';
            let payload = {};
            if (this.data.type == 8 || this.data.type == 13) {
                api = 'influencer/mergeSfaDr';
                payload = {
                    'type': this.data.type,

                    prev_id: this.data.partyId,
                    'new_id': this.data.dis_id
                }

            } else {
                api = 'CustomerNetwork/mergingCustomerInfo';
                payload = {
                    'type': this.data.type, 'merge_to_id': this.data.dis_id, 'dr_id': this.data.partyId
                }
            }

            this.serve.post_rqst(payload, api).subscribe((result => {
                if (result['statusCode'] == 200) {

                    this.toast.successToastr(result['statusMsg']);
                    this.dialog.closeAll();
                }
                else {


                    this.toast.errorToastr(result['statusMsg']);
                }
            }));
        });



    }
}